<template>
    <div class="col-span-full grid-cols-subgrid gap-x-3 grid items-center min-w-0 justify-end lg:col-span-1">
        <div class="block text-xs text-slate-500 lg:hidden" :class="[props.labelClasses]">
            <slot name="label"></slot>
        </div>
        <div class="text-sm flex items-center max-w-full min-w-0" :class="[props.contentClasses]">
            <span class="truncate min-w-0">
                <slot></slot>
            </span>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    labelClasses: {
        type: String,
        default: '',
    },
    contentClasses: {
        type: String,
        default: '',
    },
});
</script>
